//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mfg.AM.js";
import "../no/Builder.js";
import "../Features/Features.CurveOnSurfaceBuilder.js";
import "../no/ScCollector.js";
import "../no/Features.js";
import "../no/ScCollector.js";
let d=[[[0,"CloseCurve",1,0],[1,"CurveOnSurfaceBuilder",0,"Features.CurveOnSurfaceBuilder",0],[0,"Sketch",1,"Sketch",0],[1,"SketchCollector",0,"ScCollector",0],[0,"SketchMode",1,0]],[[["faces"],"SetSketchCanvas",{},1,0],[["points"],"AddCurvePoints",{},1,0]],[]];
SPLM.Mfg.AM.Sketcher = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mfg.AM.Sketcher";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mfg.AM.Sketcher.Mode = Object.freeze({
    "SurfaceFace" : "SurfaceFace", "SurfaceLine" : "SurfaceLine", "SketchFace" : "SketchFace", "SketchLine" : "SketchLine"});

export default SPLM;